import { Controller } from "@hotwired/stimulus"

// Storefront theme cards: reveals the colour input when "my own colour" is
// picked, and keeps that card's preview showing the colour being mixed.
//
// The preview repeats the server's contrast rule so the label stays readable
// on a light accent. StorefrontTheme remains authoritative — this only has to
// be right enough to preview, and matching it here means the card does not
// promise white-on-yellow that the saved page then corrects.
export default class extends Controller {
  static targets = ["customRow", "customRadio", "customSwatch", "colour"]

  select() {
    this.customRowTarget.classList.toggle("hidden", !this.customRadioTarget.checked)
  }

  recolour() {
    const accent = this.colourTarget.value
    this.customSwatchTarget.style.backgroundColor = accent
    this.customSwatchTarget.style.color = this.#readableOn(accent)
  }

  // Mirrors StorefrontTheme#readable_on: whichever ink measures more readable
  // on the accent, not a luminance cut-off.
  #readableOn(hex) {
    return ["#1A1A1A", "#FFFFFF"].reduce((best, ink) =>
      this.#contrastRatio(hex, ink) > this.#contrastRatio(hex, best) ? ink : best
    )
  }

  #contrastRatio(a, b) {
    const [darker, lighter] = [this.#relativeLuminance(a), this.#relativeLuminance(b)].sort((x, y) => x - y)
    return (lighter + 0.05) / (darker + 0.05)
  }

  #relativeLuminance(hex) {
    const [r, g, b] = hex
      .replace("#", "")
      .match(/../g)
      .map((pair) => {
        const srgb = parseInt(pair, 16) / 255
        return srgb <= 0.03928 ? srgb / 12.92 : Math.pow((srgb + 0.055) / 1.055, 2.4)
      })

    return 0.2126 * r + 0.7152 * g + 0.0722 * b
  }
}
